export default "__VITE_ASSET__Cb33agoB__"